"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormStep1 = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@mui/material/styles");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const ArrowForward_1 = __importDefault(require("@mui/icons-material/ArrowForward"));
const useConfig_1 = require("../../hooks/useConfig");
const PoweredBy_1 = require("../parts/PoweredBy");
const useCurrentPage_1 = require("../../hooks/useCurrentPage");
// Temp. Move to the MultiStepForm later.
// interface StepProps {
//   values: object
//   errors: object
//   touched: object
//   isSubmitting: boolean
//   addAnotherChild: (values: object) => void
//   editChild: (index: number, action: string, values: object) => void
//   editIndex: number
//   handleEditChildren: () => void
// }
const StyledDisclaimer = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    '& div': {
        marginTop: theme.spacing(2),
    },
    color: theme.palette.custom.textLight,
    a: {
        textDecoration: 'underline',
    },
}));
const FormStep1 = () => {
    const setCurrentPage = (0, useCurrentPage_1.useSetCurrentPage)();
    const config = (0, useConfig_1.useConfig)();
    const headingText = (config === null || config === void 0 ? void 0 : config.headingText) || 'Fee Calculator';
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!(config === null || config === void 0 ? void 0 : config.hideHeading) && ((0, jsx_runtime_1.jsx)(Typography_1.default, { variant: "h4", sx: { paddingBottom: 3 }, children: headingText })), (0, jsx_runtime_1.jsx)(Typography_1.default, { variant: "body1", sx: { paddingBottom: 3 }, children: (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: {
                        __html: (config === null || config === void 0 ? void 0 : config.terms.homeWelcomeText) || '',
                    } }) }), (0, jsx_runtime_1.jsx)(Button_1.default, { variant: "contained", color: "primary", type: "button", size: "large", disableElevation: true, onClick: () => setCurrentPage({ page: 'students' }), endIcon: (0, jsx_runtime_1.jsx)(ArrowForward_1.default, {}), children: "GET STARTED" }), (0, jsx_runtime_1.jsx)(StyledDisclaimer, { variant: "caption", children: (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: {
                        __html: (config === null || config === void 0 ? void 0 : config.terms.homeTermsOfUse) || '',
                    } }) }), (0, jsx_runtime_1.jsx)(StyledDisclaimer, { variant: "caption", children: (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: (config === null || config === void 0 ? void 0 : config.terms.disclaimer) || '' } }) }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(PoweredBy_1.PoweredBy, { hideLogo: true })] }));
};
exports.FormStep1 = FormStep1;
